import { render } from "./DeleteRequest.vue?vue&type=template&id=ff2121c0"
import script from "./DeleteRequest.vue?vue&type=script&lang=js"
export * from "./DeleteRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__